module.exports = __webpack_public_path__ + "img/nomad1.b943d66e.jpg";